import { render } from "./ContractModelCreate.vue?vue&type=template&id=06a23f02"
import script from "./ContractModelCreate.vue?vue&type=script&lang=js"
export * from "./ContractModelCreate.vue?vue&type=script&lang=js"

import exportComponent from "C:\\frotend\\d7m_front_end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__